import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {NgbModal, NgbModalOptions, NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {ISFListFilter, ISFListFilterData} from "./isf.list.filter";
import {Subject} from "rxjs";
import {MessageListResponse, VShipperSubmission} from "../../../shipper";
import {FormsModule} from "@angular/forms";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {TemplateService} from "../../template.service";
import {IsfVew} from "../view/isf.vew";
import {ISFBills} from "../isf.bills";
import {ISFSubmissionStatus} from "../isf.submission.status";






@Component({
    selector: "isf-list",
    standalone: true,
    imports: [
        FormsModule,
        ISFListFilter,
        NgbPagination,
        ISFBills,
        NgIf,
        DatePipe,
        ISFSubmissionStatus,
        NgForOf
    ],
    templateUrl: "isf.list.html"
})
export class ISFSubmissionList implements OnInit, OnDestroy{

    isf:MessageListResponse<VShipperSubmission> = <MessageListResponse<VShipperSubmission>>{number:1};

    @ViewChild("filter",{static:true})
    filter!:ISFListFilter;

    filterData:ISFListFilterData = new ISFListFilterData();

    selected:Array<number> = [];

    selectAll:boolean = false;

    modalConf = <NgbModalOptions>{
        backdrop : 'static',
        keyboard : false,
        size : "xl"
    };
    
    /** To prevent double-clicks **/
    submitDisable = false;
    
    private destroy$ = new Subject<void>();
    
   
    
    constructor(private service:TemplateService, private modal:NgbModal) {}
    
    
    
    
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    /**
     *
     */
    ngOnInit(): void {
       this.getData();

    }


    /**
     *
     * @param isf
     */
    view(id:number){

        let modal = this.modal.open(IsfVew,{fullscreen:true});
        
        modal.componentInstance.id = id;
        //43760
        //modal.componentInstance.id = 43742;
    }

    

    /**
     *
     * @param page
     */
    pageChange(page:any){
        
        this.filterData.page = page;

        this.getData();
    }


    /**
     *
     * @param page
     * @param filter
     */
    getData(){
        
        this.service.search(this.filterData).subscribe((data) => {
            this.isf = data;
        })
    
    }


    /**
     *
     * @param ev
     */
    search(ev: any){
        this.filterData = ev;
        

        this.getData();
    }


    /**
     *
     * @param ev
     * @param id
     */
    isfSelections(ev:any, id:number){

        console.log(ev.target.checked, id);
        
        if(ev.target.checked){
            this.selected.push(id);
            return;
        }

        this.selected = this.selected.filter((i) => i!=id);
    }
    
    
    isSelectable(isf:VShipperSubmission){
        return (isf.status == "TRANSMITTED" ||
            isf.status == "DELETED" ||
            isf.status =="LOCKED");
    }


    selectAllItems(){

        if(!this.selectAll){
            this.selected = [];
            return;
        }

        this.isf.content
            //.filter((i) => !this.isSelectable(i))
            .forEach((i) => this.selected.push(i.id));
    }



    /**
     * Get PDF confirmations for accepted isf's
     */
    getPdfConfirmation():void{

        let ids:Array<number> = this.isf.content
            .filter((i) => this.selected.includes(i.id))
            .filter((i) => i.status=="ACCEPTED")
            .map((i) => i.id);

        //if(ids.length == 0){return false;}


        /*
        this.isfDataService.getPdfFilingProof(ids).subscribe((data) => {
            const blob = new Blob([data], { type: 'application/zip' });
            const url= window.URL.createObjectURL(blob);
            window.open(url);
        });
        
         */
        
        
    }
    
}


